





import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { checkMobile } from '../../utils/utils'
import CourseMyDetailMobile from './CourseMyDetailMobile.vue'
import CourseMyDetailWeb from './CourseMyDetailWeb.vue'

@Component({
  components: {
    CourseMyDetailMobile,
    CourseMyDetailWeb,
  }
})
export default class CourseDetail extends Vue {
  mobile = checkMobile()
}
